// extracted by mini-css-extract-plugin
export default {"button":"RegistrationSuccessModal_button__7TZ6f"};